import { Observable, of } from 'rxjs';
import { getImgMock, randomNum } from '@hglobal/common';
import { UserMentoringTaskDetail } from '@pt/models';

import { GetTaskDetailsRes } from '../models';

export function getTaskDetailsMock(id: number): Observable<GetTaskDetailsRes> {
  const baseInfo = {
    id,
    title: `Task name ${id}`,
    description: `Task description ${id}`,
    completed: !!(
      randomNum(2, 1) % 2
    ),
  };

  const options: UserMentoringTaskDetail[] = [
    {
      ...baseInfo,
      image: getImgMock(),
      videoUrl: 'https://www.youtube.com/embed/o74WSoJxGPI?si=HVofDy3G6vpVi6Cq',
      button: {
        name: 'Button name 1',
        url: 'https://www.youtube.com/watch?v=o74WSoJxGPI&ab_channel=DecodedFrontend',
      },
      pdfButton: { name: 'Open PDF', pdf: getImgMock() },
      confirmationType: 'manual',
    },
    {
      ...baseInfo,
      image: getImgMock(),
      videoUrl: '',
      button: { name: '', url: '' },
      pdfButton: { name: '', pdf: getImgMock() },
      entity: {
        id: 1,
        entityType: 'quest',
        type: 'quest', // to match TaskEntityBase interface
        mainImage: getImgMock(),
      },
      confirmationType: 'auto',
    },
    {
      ...baseInfo,
      image: getImgMock(),
      videoUrl: '',
      button: { name: '', url: '' },
      pdfButton: { name: '', pdf: getImgMock() },
      confirmationType: 'auto',
      entity: {
        id: 2,
        entityType: 'course',
        type: 'course', // to match TaskEntityBase interface
        mainImage: getImgMock(),
      },
    },
  ];

  return of(options[randomNum(2, 0)]);
}
